module.exports = __webpack_public_path__ + "img/home-restaurant-thumb-04-on.9f4412d4.jpg";